import { render, staticRenderFns } from "./YourTasksTab.vue?vue&type=template&id=8304cba4&scoped=true"
import script from "./YourTasksTab.vue?vue&type=script&setup=true&lang=js"
export * from "./YourTasksTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourTasksTab.vue?vue&type=style&index=0&id=8304cba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8304cba4",
  null
  
)

export default component.exports